import { render, staticRenderFns } from "./globalModGroup.vue?vue&type=template&id=2b868b45"
import script from "./globalModGroup.vue?vue&type=script&lang=js"
export * from "./globalModGroup.vue?vue&type=script&lang=js"
import style0 from "./globalModGroup.vue?vue&type=style&index=0&id=2b868b45&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b868b45')) {
      api.createRecord('2b868b45', component.options)
    } else {
      api.reload('2b868b45', component.options)
    }
    module.hot.accept("./globalModGroup.vue?vue&type=template&id=2b868b45", function () {
      api.rerender('2b868b45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/globalMods/globalModGroup.vue"
export default component.exports